import toast from "react-hot-toast";

const { clientAPI } = require("../client");
export const transferRequestsCall = {
  updateStatus: async (id, data) => {
    try {
      const response = await clientAPI("put", `/transferRequests/updateStatus/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
